import React from "react";
import { FeatureArticleRichText } from "web/react/components/feature-article/feature-article-rich-text";
import { withHardBreaks } from "web/react/components/feature-article/utils";
import { Heading } from "web/react/emo/heading";
import { VStack } from "web/react/emo/v-stack";
import { View } from "web/react/emo/view";

interface FeatureArticleTextBoxProps {
    heading: string | null;
    markdown: string;
}

export function FeatureArticleTextBox({
    heading,
    markdown,
}: FeatureArticleTextBoxProps): React.ReactElement {
    return (
        <View padding={{ sm: "md", md: "lg" }} background="grayscale200">
            <VStack spacing="md">
                {heading && (
                    <Heading as="h4" textStyle="caption-s" color="primary" upperCase>
                        {heading}
                    </Heading>
                )}
                <FeatureArticleRichText color="primary">
                    {withHardBreaks(markdown)}
                </FeatureArticleRichText>
            </VStack>
        </View>
    );
}
